module.exports = __webpack_public_path__ + "img/metal_v@2x.baff8f51.png";